import { render, staticRenderFns } from "./PurchaseInvoiceImport.vue?vue&type=template&id=cf5e003c&scoped=true&lang=pug&"
import script from "./PurchaseInvoiceImport.vue?vue&type=script&setup=true&lang=js&"
export * from "./PurchaseInvoiceImport.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PurchaseInvoiceImport.vue?vue&type=style&index=0&id=cf5e003c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5e003c",
  null
  
)

export default component.exports